import { Footer } from './DocumentFooter.styles';

const DocumentFooter = ({ loading, disabled, onClick, children }) => {
	if (loading) return null;

	return (
		<Footer className="doca">
			<button className="doca-button doca-button--primary" disabled={disabled} onClick={onClick}>
				{children}
			</button>
		</Footer>
	);
};

export default DocumentFooter;
